import {  STAFFS_DATA } from "../../constants/ActionTypes";

const INIT_STATE = {
    staffs: [],
};

const staffReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case STAFFS_DATA: {
            return {
                ...state,
                staffs: action.payload,
            }
        }
        default:
            return state;
    }
}

export default staffReducer;
